import at from 'lodash/at';
import React, { ChangeEvent } from 'react';

import { ValueBox, ValueInput } from '@candu-ai/craft/ui';
import { TriggerClickAction } from 'craft/types';

import { InteractionFieldProps } from './interactionFields';

export const TriggerClickField = ({
  defaultValue,
  onChange,
}: InteractionFieldProps<TriggerClickAction['handler']>) => {
  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    return onChange({ ...defaultValue, selector: value });
  };

  return (
    <ValueBox
      label="Selector"
      tooltip="This action will trigger a click on the target matching this CSS selector"
      isInGroup={{ isLast: true }}
    >
      <ValueInput
        placeholder=".my-target-selector"
        value={at(defaultValue as any, 'selector')[0]}
        onChange={onChangeHandler}
      />
    </ValueBox>
  );
};
